import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionStoreService } from '../services/session-store.service';
import { VERSION } from './../../../environments/version';
import { AuthenticationService } from './../http/authentication.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthenticationService);
  private readonly sessionStoreService = inject(SessionStoreService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.sessionStoreService.getData<string>('sessionToken');

    if (this.auth && this.auth.sessionToken) {
      token = this.auth.sessionToken;
    }
    //kein Session-Token senden
    if (!token) {
      return next.handle(request);
    }

    const header = {
      setHeaders: {
        'X-BauPlusWeb-SessionToken': `${token}`,
        'X-BauPlusWeb-App': `WebApp-${VERSION.version}`,
      },
    };

    const requestClone = request.clone(header);
    return next.handle(requestClone);
  }
}
